/**
 * Enumeration of total loss types for a damaged vehicle.
 *
 * - TECHNICAL: The vehicle is irreparable or not roadworthy anymore.
 * - ECONOMIC: Repair costs exceed the replacement value of the vehicle.
 */
export enum TotalLossType {
  /**
   * Technical total loss: The vehicle cannot be repaired due to the extent of damage
   * (e.g. structural integrity compromised, safety no longer guaranteed).
   */
  TECHNICAL = "technical",

  /**
   * Economic total loss: The cost of repair exceeds the vehicle's replacement value,
   * making the repair financially unreasonable.
   */
  ECONOMIC = "economic"
}
